import gql from 'graphql-tag';


export const LOGIN = gql`
  mutation loginUser($input: loginUserInput!) {
   loginUser(input: $input) {
      id
      email
      affiliate
      lastLogin
      admin
      moduleCompletion {
        idModule
        latestScore
        NumberOfAttempt
        questionCount
      }
    }
  }
`;

export const GET_INFOS = gql`
  query {
    user {
      moduleCompletion {
        idModule
        latestScore
        NumberOfAttempt
      }
    }
  }
`;

export const LOGOUT = gql`
  mutation userLogout {
    userLogout
  }
`;

export const FIRST_LOG = gql`
  mutation firstLog($input: firstLogInput!) {
   firstLog(input: $input) {
      id
      email
      affiliate
      lastLogin
      moduleCompletion {
        idModule
        latestScore
        NumberOfAttempt
      }
    }
  }
`;

export const RESET_PASSWORD = gql`
  mutation resetPassword($email: String!) {
    resetPassword(email: $email)
  }
`;

export const SET_PASSWORD = gql`
  mutation setPassword($input: setPasswordInput!) {
    setPassword(input: $input) 
  }
`;

export const GET_MODULES = gql`
  query {
    modules {
      id
      title
      label
      videoCount
      quizCount
      questionCount
      cardDescription
      estimateOfCompletionTime
    }
  }
`;

export const GET_MODULE = function (id) {
  return gql`
    query {
      module(id: ${id}) {
        id
        title
        label
        description
        videoCount
        quizCount
        questionCount
        estimateOfCompletionTime
        quiz {
          id
          title
          questions {
            question
            options {
              value
              correct
            }
          }
        }
        videos {
          id
          description
          link
          title
          duration
          footer
          link
        }
      }
    }
  `
};

export const SEND_RESULT = gql`
  mutation AddCompletion($input: CompletionInput!) {
    AddCompletion(input: $input) {
      id
    }
  }
`;
